<!--
 * @Author: wxb
 * @Date: 2021-11-17 11:11:11
 * @LastEditors: 王兴彬 18254141586@163.com
 * @LastEditTime: 2022-07-15 15:25:14
 * @Description:
-->
<template>
  <div class="containner">
    <div class="quotation">
      <div class="quotation-title">报价单比对</div>
      <div class="quotation-content">
        <div class="quotation-baseinfo">
          <div class="quotation-baseinfo-title">报价单主信息比对</div>
          <div class="quotation-baseinfo-content">
            <el-table :data="tableData"
                      border
                      style="width: 100%">
              <el-table-column>
                <template slot="header"
                          slot-scope="scope">
                  <el-checkbox v-model="scope._self.showDiff4Main">显示不同项</el-checkbox>
                  <el-checkbox v-model="scope._self.showSame4Main">显示相同项</el-checkbox>
                </template>
                <template slot-scope="scope">
                  {{scope.row.name}}
                </template>
              </el-table-column>
              <el-table-column v-for="(item,index) in quotationHeader4table"
                               :key="index"
                               :prop="item.key"
                               header-align="center"
                               :label="item.name"
                               align="center">
                <template slot-scope="scope">
                  <span :class="diffClass(scope.row,item.key,'value')">{{scope.row[item.key]}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="quotation-product">
          <div class="quotation-product-title">报价单产品信息比对</div>
          <div class="quotation-product-content">
            <el-table :data="tableData4Product"
                      border
                      style="width: 100%"
                      :height="maxheight">
              <el-table-column>
                <template slot="header"
                          slot-scope="scope">
                  <el-select v-model="scope._self.showRule"
                             clearable
                             @change="updateProductTable"
                             placeholder="请选择">
                    <el-option v-for="item in options"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                  </el-select>
                </template>
                <el-table-column prop="SECTION_NAME"
                                 label="章节名称"
                                 min-width="120"
                                 fixed>
                </el-table-column>
                <el-table-column prop="DETAILS_CPBH"
                                 label="产品编号"
                                 min-width="120"
                                 fixed>
                </el-table-column>
                <el-table-column prop="DETAILS_CPMC"
                                 label="产品名称"
                                 min-width="120"
                                 fixed>
                </el-table-column>
              </el-table-column>
              <el-table-column v-for="(item,index) in productHeader"
                               :key="index"
                               width="240"
                               align="center">
                <template slot="header"
                          slot-scope="scope">
                  <div class="text-ellipsis">{{scope._self.productHeader[index].QUOTATION_BJMC}}</div>
                </template>
                <el-table-column :prop="`goodsprice${item.PROJECT_QUOTATION_ID}`"
                                 label="价格"
                                 align="right"
                                 header-align="center"
                                 width="120">
                  <template slot-scope="scope">
                    <span :class="diffClass(scope.row,`goodsprice${item.PROJECT_QUOTATION_ID}`,'goodsprice')">{{scope.row[`goodsprice${item.PROJECT_QUOTATION_ID}`]}}</span>
                  </template>
                </el-table-column>
                <el-table-column :prop="`goodsnums${item.PROJECT_QUOTATION_ID}`"
                                 header-align="center"
                                 label="数量"
                                 align="center"
                                 width="120">
                  <template slot-scope="scope">
                    <span :class="diffClass(scope.row,`goodsnums${item.PROJECT_QUOTATION_ID}`,'goodsnums')">{{scope.row[`goodsnums${item.PROJECT_QUOTATION_ID}`]}}</span>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { quotationComparison } from '@/api/common/compareQuotation'
const tableHeader4Main = [{
  name: '报价总额（未税）',
  code: 'QUOTATION_BJZEWS'
}, {
  name: '税额',
  code: 'QUOTATION_SE'
}, {
  name: '报价总额（含税）',
  code: 'QUOTATION_BJZEHS'
}, {
  name: '折扣方式',
  code: 'QUOTATION_ZKFS'
}, {
  name: '折扣数值',
  code: 'QUOTATION_ZKSE'
}, {
  name: '折扣后报价总额',
  code: 'QUOTATION_ZKHBJZEHS'
}, {
  name: '报价产品总数',
  code: 'NUM'
}]
export default {
  name: 'compareQuotation',
  data() {
    return {
      showDiff4Main: true,
      showSame4Main: false,
      tableData: [],
      quotationHeader4table: [],
      allMainTableData: [],
      showRule: '1',
      options: [{
        value: '1',
        label: '不同项'
      }, {
        value: '2',
        label: '相同项'
      }, {
        value: '3',
        label: '仅价格不一样'
      }, {
        value: '4',
        label: '仅数量不一样'
      }],
      productHeader: [],
      allProductTableData: [],
      tableData4Product: [],
      maxheight: 600
    }
  },
  watch: {
    showDiff4Main(val) {
      if (val) {
        this.showSame4Main = false
      }
      this.updateMainTableData()
    },
    showSame4Main(val) {
      if (val) {
        this.showDiff4Main = false
      }
      this.updateMainTableData()
    }
  },
  methods: {
    // 对比信息标红
    diffClass(row, key, valueKey) {
      let flag = true
      const keys = Object.keys(row)
      const valueKeys = keys.filter(item => item.indexOf(valueKey) !== -1)
      if (valueKeys.length === 2) {
        // 两个，如果不一样都标红
        flag = !(row[valueKeys[0]] === row[valueKeys[1]])
      } else if (valueKeys.length > 2) {
        const arr = []
        for (const item of valueKeys) {
          arr.push(row[item])
        }
        const total = this.countOccurences(arr, row[key])
        const arrLength = arr.length
        if (total === arrLength - 1) {
          // 两个以上，当n-1个一样时，不一样的一个标红
          flag = false
        } else {
          // 非上述情况都标红
          flag = true
        }
      } else if (valueKeys.length === 1) {
        // 一个时,不需要标红
        flag = false
      }
      return { diff: flag }
    },
    // 计算一个值在数组中出现的次数
    countOccurences(arr, value) {
      return arr.reduce((a, v) => v === value ? a + 1 : a + 0, 0)
    },
    // 更新主信息对比列表
    updateMainTableData() {
      let list = []
      if (this.showDiff4Main) {
        // 显示不同项
        list = this.allMainTableData.filter(value => !value.issame)
      } else if (this.showSame4Main) {
        // 显示相同项
        list = this.allMainTableData.filter(value => value.issame)
      } else {
        list = this.allMainTableData
      }
      this.tableData = list
    },
    // 结构化主信息对比列表
    handleOfferList(offerList) {
      for (const item of tableHeader4Main) {
        const code = item.code
        const valueSet = new Set()
        offerList.forEach((ele, idx) => {
          const value = ele[code]
          valueSet.add(value)
          const key = `value${idx}`
          item[key] = value
          const name = ele.QUOTATION_BJMC
          const index = this.quotationHeader4table.findIndex(it => it.key === key)
          if (index === -1) {
            this.quotationHeader4table.push({
              name,
              key
            })
          }
        })
        item.issame = valueSet.size === 1
      }
      this.allMainTableData = JSON.parse(JSON.stringify(tableHeader4Main))
      this.updateMainTableData()
    },
    // 结构化报价单产品信息对比
    handleProductList(productList) {
      // 对productList进行分组，按照产品进行分组
      const list = []
      for (const item of productList) {
        const idx = list.findIndex(value => value.DETAILS_CPBH === item.DETAILS_CPBH && value.LIST_SECTION_NAME_ID === item.LIST_SECTION_NAME_ID)
        //  报价单中的产品信息
        const productInfo = {
          PROJECT_QUOTATION_ID: item.PROJECT_QUOTATION_ID,
          QUOTATION_BJMC: item.QUOTATION_BJMC,
          DETAILS_SL: item.DETAILS_SL,
          DETAILS_DJ: item.DETAILS_DJ
        }
        if (idx === -1) {
          list.push({
            DETAILS_CPBH: item.DETAILS_CPBH,
            DETAILS_CPMC: item.DETAILS_CPMC,
            SECTION_NAME: item.SECTION_NAME,
            LIST_SECTION_NAME_ID: item.LIST_SECTION_NAME_ID,
            quotationArr: [productInfo]
          })
        } else {
          list[idx].quotationArr.push(productInfo)
        }
        const idx4header = this.productHeader.findIndex(value => value.PROJECT_QUOTATION_ID === item.PROJECT_QUOTATION_ID)
        if (idx4header === -1) {
          this.productHeader.push({
            PROJECT_QUOTATION_ID: item.PROJECT_QUOTATION_ID,
            QUOTATION_BJMC: item.QUOTATION_BJMC
          })
        }
      }
      // 根据报价单表头信息进行数据填充
      for (const item of this.productHeader) {
        const code = item.PROJECT_QUOTATION_ID
        for (const it of list) {
          const quotationArr = it.quotationArr
          const idx = quotationArr.findIndex(v => v.PROJECT_QUOTATION_ID === code)
          if (idx === -1) {
            quotationArr.push({
              PROJECT_QUOTATION_ID: item.PROJECT_QUOTATION_ID,
              QUOTATION_BJMC: item.QUOTATION_BJMC,
              DETAILS_SL: '-',
              DETAILS_DJ: '-'
            })
          }
        }
      }
      // 添加价格和数量是否一样标识
      for (const item of list) {
        const quotationArr = item.quotationArr
        const priceSet = new Set()
        const numsSet = new Set()

        for (const it of quotationArr) {
          const priceKey = `goodsprice${it.PROJECT_QUOTATION_ID}`
          const numsKey = `goodsnums${it.PROJECT_QUOTATION_ID}`
          item[priceKey] = it.DETAILS_DJ
          item[numsKey] = it.DETAILS_SL
          priceSet.add(it.DETAILS_DJ)
          numsSet.add(it.DETAILS_SL)
        }
        // 产品价格不一样
        if (priceSet.size !== 1) {
          item.priceDiff = true
        } else {
          item.priceDiff = false
        }
        // 产品数量不一样
        if (numsSet.size !== 1) {
          item.numsDiff = true
        } else {
          item.numsDiff = false
        }
      }
      this.allProductTableData = list
      this.updateProductTable()
    },
    // 更新产品列表信息
    updateProductTable() {
      let list = []
      const showRule = this.showRule
      if (showRule === '1') {
        // 产品价格和产品数量不一样的显示
        list = this.allProductTableData.filter(value => value.priceDiff || value.numsDiff)
      } else if (showRule === '2') {
        // 产品价格和产品数量都一样的显示
        list = this.allProductTableData.filter(value => !value.priceDiff && !value.numsDiff)
      } else if (showRule === '3') {
        // 仅价格不一样
        list = this.allProductTableData.filter(value => value.priceDiff && !value.numsDiff)
      } else if (showRule === '4') {
        // 仅数量不一样
        list = this.allProductTableData.filter(value => !value.priceDiff && value.numsDiff)
      } else {
        list = this.allProductTableData
      }
      this.tableData4Product = list
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.maxheight = window.innerHeight - 90
    })
    const params = this.$route.params
    quotationComparison(params).then(res => {
      if (res.success) {
        const offerList = res.obj.offerList
        this.handleOfferList(offerList)
        const productList = res.obj.productList
        this.handleProductList(productList)
      }
    }).catch(err => console.log(err))
  }
}
</script>

<style lang="scss" scoped>
.containner {
  background: #f0f2f5;
  padding: 28px 20px;
  min-height: 100vh;
}
.quotation {
  &-title {
    padding: 20px;
    font-family: PingFangSC-Medium;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.65);
    font-weight: 500;
    margin-bottom: 20px;
    background: #fff;
  }

  &-baseinfo {
    background: #fff;
    border-radius: 8px;
    &-title {
      padding: 10px 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.65);
      font-weight: 500;
    }

    &-content {
      padding: 0 0 10px 0px;
    }
  }

  &-product {
    background: #fff;
    border-radius: 8px;
    margin-top: 20px;
    &-title {
      padding: 10px 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.65);
      font-weight: 500;
    }

    &-content {
      padding: 0 0 10px 0px;
    }
  }

  .diff {
    color: #ff2f2f;
    font-weight: 700;
  }
}
</style>
<style>
/* 滚动条的宽度 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #e4e4e4;
  border-radius: 6px;
}
/* 滚动条的滑块 */
::-webkit-scrollbar-thumb {
  background-color: #a1a3a9;
  border-radius: 6px;
}
</style>
